module.exports = __webpack_public_path__ + "img/cl.fbb82993.gif";